import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/cn.js';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  padded?: boolean;
}

export function Card({
  padded = true,
  className,
  ...rest
}: CardProps) {
  return (
    <div
      className={cn(
        'bg-ink-800 border border-ink-600 rounded-[10px] shadow-card',
        padded && 'p-4',
        className
      )}
      {...rest}
    />
  );
}
